var customerId = $('.ga_customerId').val();
var loginPageurl = "/account/login";
var registerPageUrl = "/account/register";
var cookieValueObj = {};

if(customerId === undefined || customerId === ''){
  var currentPageUrl = location.href;
  var isLoginPageUrl = currentPageUrl.indexOf(loginPageurl);
  var isRegisterPageUrl = currentPageUrl.indexOf(registerPageUrl);
  
  if(isLoginPageUrl == -1 && isRegisterPageUrl == -1){
    if( typeof(Storage) !== undefined ){
       sessionStorage.setItem("redirectionPageUrl",currentPageUrl);
    }
    //     cookies storage
    if(navigator){
      var isCookiesEnabled = navigator.cookieEnabled;
      if(isCookiesEnabled === true){
        document.cookie = "redirectionPageUrl="+currentPageUrl+";path=/";
      }
    }
  }
}
else{
//   this code is to redirectt the customer to the previous page after successfully login
  var redirectionUrl = "";
  if( typeof(Storage) !== undefined ){
    var isRedirectionPageUrlExists = localStorage.hasOwnProperty("redirectionPageUrl");
    if(isRedirectionPageUrlExists === true){
      redirectionUrl = sessionStorage.getItem("redirectionPageUrl");
      sessionStorage.removeItem("redirectionPageUrl");
      redirectToPreviousPage(redirectionUrl);
    }
    else{
      createCookieObj();
      if(!($.isEmptyObject(cookieValueObj))){
        var isRedirectionUrlExists = cookieValueObj.hasOwnProperty("redirectionPageUrl");
        if(isRedirectionUrlExists === true){
          if(cookieValueObj.redirectionPageUrl !== null && cookieValueObj.redirectionPageUrl !== ""){
            redirectionUrl = cookieValueObj.redirectionPageUrl;
            document.cookie = "redirectionPageUrl=;path=/";
            redirectToPreviousPage(redirectionUrl);
          }
        }
      }
    }
  }
  else{
    createCookieObj();
    if(!($.isEmptyObject(cookieValueObj))){
      var isRedirectionUrlExists = cookieValueObj.hasOwnProperty("redirectionPageUrl");
      if(isRedirectionUrlExists === true){
        if(cookieValueObj.redirectionPageUrl !== null && cookieValueObj.redirectionPageUrl !== ""){
          redirectionUrl = cookieValueObj.redirectionPageUrl;
          document.cookie = "redirectionPageUrl=;path=/";
          redirectToPreviousPage(redirectionUrl);
        }
      }
    }
  }
}

// this function is to create the cookies object
function createCookieObj() {
  var cookiesValues = document.cookie;
  if(cookiesValues !== ""){
    var cookieValuesArray = cookiesValues.split(";");
    var cookiesValueArrayLength = cookieValuesArray.length;
    if(cookiesValueArrayLength>0){
      var i;
      for(i=0;i<cookiesValueArrayLength;i++){
        var cookieValues = (cookieValuesArray[i]).trim();
        var indexOfEqual = cookieValues.indexOf("=");
        if(indexOfEqual !== -1){
          var stringLength = cookieValues.length;
          var cookieObjKey = (cookieValues.slice(0,indexOfEqual)).trim();
          var cookieObjValue = (cookieValues.slice(indexOfEqual+1,stringLength)).trim();
          cookieValueObj[cookieObjKey] = cookieObjValue;
        }
      }
    }
  }
}

// function to redirection to the previous page
function redirectToPreviousPage(pageUrl){
  var homePageUrl = window.origin;
  if(pageUrl !== undefined && pageUrl !== ""){
    location.assign(pageUrl);
    
  }
  else{
    location.assign(homePageUrl);
  }
}